
console.log('Vite ⚡️ Ruby')

import '../js/audiowaves.js'

